import { CSSProperties, FC } from 'react';

export interface SvgInfoCircleProps {
  size?: string; // size of square container
  style?: CSSProperties; // not for height or width
}

export const SvgInfoCircle: FC<SvgInfoCircleProps> = ({
  size = '24px',
  style,
}) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...style,
      height: size,
      width: size,
    }}
  >
    <div
      style={{
        position: 'relative',
        height: 0,
        width: '100%',
        padding: 0,
        paddingBottom: '100%',
      }}
    >
      <svg
        style={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          left: 0,
          top: 0,
        }}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="8"
          cy="8"
          r="7"
          stroke="#C4C4C4"
          strokeWidth="2"
          fill="currentColor"
        />
        <path
          d="M8 8v2M8 5v.09"
          stroke="#C4C4C4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="currentColor"
        />
      </svg>
    </div>
  </div>
);
